/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { cn } from "@farmlands/shadcn-ui";
import { ReactNode } from "react";

export type NavItemModel = {
  id: string;
  label: string;
  icon: ReactNode;
  isActive: boolean;
  testId?: string;
  onSelect: () => void;
};

export type NavItemSize = "sm" | "lg";

type NavItemProps = NavItemModel & { size: NavItemSize };

export const NavItem = ({ label, icon, isActive, testId, onSelect, size }: NavItemProps) => (
  <li className={size === "sm" ? "flex-1 px-1" : undefined}>
    <button
      type="button"
      data-active={isActive}
      data-testid={testId}
      onClick={onSelect}
      className={cn(
        `
          group flex w-full cursor-pointer flex-col items-center justify-center gap-1 rounded-lg
          text-morning-dew-50 transition-colors outline-none
          focus-visible:ring-[3px] focus-visible:ring-white
        `,
        size === "sm" ? "py-1.5" : "aspect-square overflow-hidden px-1 text-center"
      )}
    >
      <span
        className={cn(
          "items-center justify-center rounded-full transition-colors",
          size === "sm" ? "flex h-6 w-12" : "inline-flex px-4 py-1",
          isActive
            ? "bg-forest-green-800"
            : "group-hover:bg-forest-green-600 group-active:bg-forest-green-900"
        )}
      >
        {icon}
      </span>
      <span
        className={
          size === "sm"
            ? "text-[0.75rem] leading-[0.875rem] font-medium tracking-[0.12px]"
            : "text-2xs leading-4 font-semibold tracking-[0.5px]"
        }
      >
        {label}
      </span>
    </button>
  </li>
);
